import { NgModule } from '@angular/core';
import { FlashComponent } from '../flash/flash.component';
import { BrowserModule } from '@angular/platform-browser';
import { TimeBarComponent } from '../time-bar/time-bar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [FlashComponent, TimeBarComponent],
  imports: [
      BrowserModule,
      BrowserAnimationsModule
  ],
  exports: [FlashComponent, TimeBarComponent]
})
export class FlashCustomComponent {}